/* eslint-disable jsx-a11y/no-static-element-interactions */
/*
 * Created Date: 26-01-2024, 11:56:26 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Wed Jan 31 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import MoreVertIcon from '@mui/icons-material/MoreVert'
import { IconButton } from '@mui/material'
import List from '@mui/material/List'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import * as React from 'react'

const DropDownAction = ({ className = '', options = [], triggerElement, classNameWrapTrigger }) => {
	const [anchorEl, setAnchorEl] = React.useState(null)

	const open = Boolean(anchorEl)
	const handleClickListItem = event => {
		setAnchorEl(event.currentTarget)
	}

	const handleMenuItemClick = action => {
		setAnchorEl(null)
		action()
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	return (
		<>
			<List className="p-0 cursor-pointer" component="nav" aria-label="Device settings">
				<div className={classNameWrapTrigger} onClick={handleClickListItem}>
					{triggerElement || (
						<IconButton>
							<MoreVertIcon />
						</IconButton>
					)}
				</div>
			</List>
			<Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
				{options.map((option, index) => (
					<MenuItem
						className={clsx('bg-white hover:bg-[#F3F2F5]', option.className ?? '')}
						style={{ borderBottom: option?.divider ? '1px solid #E9E7EE' : 'none' }}
						key={option.label}
						onClick={() => handleMenuItemClick(option.action)}
					>
						{option.label}
					</MenuItem>
				))}
			</Menu>
		</>
	)
}

// DropDownAction.defaultProps = {
// 	className: '',
// 	options: []
// }

DropDownAction.propTypes = {
	className: PropTypes.string,
	options: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.element, action: PropTypes.func })),
	triggerElement: PropTypes.any,
	classNameWrapTrigger: PropTypes.string
}

export default React.memo(DropDownAction)
